<nx-default-box-v2>

  <!-- label -->
  <ng-template nxTemplate="label">
    <div class="text-[1rem] font-medium leading-3r mt-[2px]">
    Zuweisung
    <p-progressSpinner
      ariaLabel="loading"
      *ngIf="isLoading"
      styleClass="ml-[6px] w-[16px] h-[16px] black-spinner"
      strokeWidth="8"/>
    </div>
  </ng-template>
  
  <!-- content -->
  <ng-container [ngTemplateOutlet]="editMode ? editTemplate : displayTemplate"></ng-container>
  
  <!-- actions -->
  <ng-template nxTemplate="mainEnd">
    <ng-container [ngTemplateOutlet]="editMode ? editActionsTemplate : displayActionsTemplate"></ng-container>
  </ng-template>
</nx-default-box-v2>

<!-- content view mode -->
<ng-template #displayTemplate>
  <div class="flex items-center space-x-2">
    {{ assignee?.displayName || '-' }}
  </div>
</ng-template>

<!-- content edit mode -->
<ng-template #editTemplate>
  <div class="mt-1" [formGroup]="form">
    <nx-edit-select-v2-input
      [formGroup]="form"
      #selectComponent  
      [placeholder]="'Nutzer auswählen'"
      [filter]="true"
      [showLabel]="false"
      [panelWidhtFull]="true"
      formControlName="selected"
      [options]="candidates"
      [dataKey]="'id'"
      [showClear]="true"
      [optionLabel]="'displayName'">
    </nx-edit-select-v2-input>
  </div>
</ng-template>

<ng-template #displayActionsTemplate>
  <nx-default-button
    [style]="'dark'"
    (click)="edit()"
    [icon]="'icon-edit'"
    [tooltip]="'Bearbeiten'">
  </nx-default-button>
</ng-template>

<ng-template #editActionsTemplate>
  <nx-default-button
    [style]="'dark'"
    class="mr-1"
    (click)="save()"
    [disabled]="isLoading || form?.pristine"
    [icon]="'icon-check'"
    [tooltip]="'Speichern'">
  </nx-default-button>
  <nx-default-button
    [style]="'dark'"
    (click)="cancel()"
    [icon]="'icon-cancel'"
    [disabled]="isLoading"
    [tooltip]="'Abbrechen'">
  </nx-default-button>
</ng-template>
